shadow$provide[189] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Inherit:{enumerable:true, get:function() {
  return Inherit;
}}});
var require$_DOT__SLASH_parent_DOT_js = require("./parent.js");
class Inherit extends require$_DOT__SLASH_parent_DOT_js.Parent {
  static initClass() {
    this.traits = ["node", "bind"];
  }
  make() {
    return this._helpers.bind.make([{to:"inherit.source", trait:"node"}]);
  }
  unmake() {
    return this._helpers.bind.unmake();
  }
  _find(trait) {
    if (this.bind.source && Array.from(this.props.traits).includes(trait)) {
      return this.bind.source._inherit(trait);
    }
    return super._find();
  }
}
Inherit.initClass();

};